import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from './Reducers';
import storageSession from 'redux-persist/lib/storage/session'

import {persistReducer} from 'redux-persist';

const createStore = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const middleware = [({
    immutableCheck: { warnAfter: 200 },
    serializableCheck: false
  })];

  if (isDevelopment)
    middleware.push(createLogger({ diff: true, collapsed: true, logErrors: true }));

  const persistConfig = {
    key: 'root',
    storage: storageSession,
  }

  const persistedReducer = persistReducer(persistConfig, rootReducer)

  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware(...middleware),
    devTools: isDevelopment
  });

  return store;
}

export default createStore;
